var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 56,
    viewBox: "0 0 28 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "left arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.4492 13.918C19.6201 13.747 19.884 13.7262 20.0781 13.8545L20.1562 13.918L21.2158 14.9775C21.3864 15.1482 21.408 15.4115 21.2803 15.6055L21.2158 15.6846L9.2666 27.6357L8.91309 27.9893L21.2178 40.2939C21.3886 40.465 21.4098 40.7288 21.2812 40.9229L21.2178 41.001L20.1562 42.0605C19.9855 42.2311 19.7223 42.2528 19.5283 42.125L19.4502 42.0605L6.67187 29.2871L6.6709 29.2861L6.5498 29.1533C6.4735 29.0608 6.40633 28.9611 6.34961 28.8555L6.27246 28.6934C6.18008 28.4713 6.13281 28.2327 6.13281 27.9922C6.13285 27.8118 6.15954 27.6328 6.21191 27.4609L6.27246 27.292C6.34171 27.1255 6.43551 26.9706 6.5498 26.832L6.6709 26.6992L6.67187 26.6973L19.4492 13.918Z",
    fill: "#1C4F36",
    stroke: "#1C4F36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.d56883f72b683b0cd5bd8648e7e61387.svg";
export { ForwardRef as ReactComponent };